module.exports = __webpack_public_path__ + "img/wav.05f0d2ab.png";